import { globalGetService, globalPostService, globalPutService,globalDeleteService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus } from '../../../utils_v2';
import { toastFlashMessage } from '../../../utils';
import { fieldValidation } from '../../../utils_v2/formValidation';
import { errorCodeReturnCondition } from '../';
export function getReturnConListApi(props={}, query={}){
  globalGetService(`contracts/${props.params.contract_slug}/return-condition-items/`, query)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({
        list: response.data.data
      })
    }
    this.setState({skeletonLoader:false});
  })
}
export function getReturnConApi(props={}, id, mode){
  this.setState({pageLoader:true});
  globalGetService(`contracts/${props.params.contract_slug}/return-condition-items/${id}/`)
  .then(response => {
    if(checkApiStatus(response)){
      this.setState({ returnCond: response.data.data, error:{}, modal:true, mode: mode === 'V' ? 'view':'edit'})
    }
    this.setState({pageLoader:false});
  })
}
export function addEditReturnConApi(props={}, data={}){
  return new Promise(
    function(resolve, reject){
      if(data.id){
        globalPutService(`contracts/${props.params.contract_slug}/return-condition-items/${data.id}/`, data)
        .then(response => {
          resolve(response)
        })
      }else{
        globalPostService(`contracts/${props.params.contract_slug}/return-condition-items/`, data)
        .then(response => {
          resolve(response)
        })
      }
    }
  )

}

export function deleteReturnConApi(props ,deleteItem) {
  this.setState({pageLoader:true});
  globalDeleteService(`contracts/${props.params.contract_slug}/return-condition-items/${deleteItem.data.id}/`)
    .then(response => {
      if (checkApiStatus(response)) {
        this.setState(prevState => ({
          ...prevState,
          list: prevState.list.filter((item, index) => item.id != deleteItem.data.id),
          deleteItem:{modal:false, data:null}
        }))
        toastFlashMessage(response?.data?.message, 'success')
      } else {
        toastFlashMessage(response?.data?.message, 'error')
      }
      this.setState({pageLoader:false});
    })
}
